module.exports = __webpack_public_path__ + "static/media/Mist.06dd6146.svg";